<!-- <p-button (onClick)="op.toggle($event)" severity="secondary" [style]="{'width': '22rem'}" styleClass="custom-button">
  @if(!loading) {
  <span class="flex align-items-center justify-content-between w-full">
      <span class="flex align-items-center">
        <span class="font-bold">{{ selectedShop?.shopName }}</span>
        <span class="pl-1">{{ " - " + (selectedShop?.shopChannel?.channelName | translate) }}</span>
      </span>
      <i class="pi pi-chevron-down"></i>
    </span>
  }@else {
    <span>{{'global.loading' | translate}}</span>
  }
 

</p-button>

<p-overlayPanel #op appendTo="body" class="w-full block">
  <ng-template pTemplate="content"> -->
    @if(loading) {
    <div class="flex justify-content-center mt-5">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" class="custom-spinner"></p-progressSpinner>
    </div>
    } @else {
    <div class="search-container flex justify-content-center mt-3 ml-2">
      <p-iconField iconPosition="left" class="w-full">
        <p-inputIcon styleClass="pi pi-search" />
        <input type="text" pInputText (keydown.enter)="onFilter($event)"
          placeholder="{{ 'settings.searchShop' | translate }}" />
      </p-iconField>
    </div>


    <div class="flex align-items-center gap-3 mb-3 mt-3">
      <p-listbox [options]="shops" [(ngModel)]="selectedShop"
        (ngModelChange)="onShopChange($event);" [style]="{ width: '22rem' }" [multiple]="false"
        [metaKeySelection]="false" [listStyle]="{ 'max-height': '220px' }" [showToggleAll]="false">


        <ng-template let-shop pTemplate="item">
          <div class="flex align-items-center gap-2">
            <span class="font-semibold">{{ shop.shopName }}</span>
            <span>{{ " - " + (shop.shopChannel.channelName | translate) }}</span>
          </div>
        </ng-template>
      </p-listbox>
    </div>

    <div class="flex justify-content-center align-items-center gap-2 mb-3" [style]="{ width: '20rem' }">
      <p-button icon="pi pi-chevron-left" (onClick)="previousPage()" [disabled]="currentPage === 0"
        severity="secondary" size="small">
      </p-button>
      <p-button icon="pi pi-chevron-right" (onClick)="nextPage()" [disabled]="!hasNext" severity="secondary"
        size="small">
      </p-button>
    </div>
    }
<!--   </ng-template>
</p-overlayPanel> -->